import { IEquipment, IEquipmentMaintenanceBlank, ILPConnectionRequest } from '../../equipment.types'
import eventBus from '../../../../services/eventBus'
import { IEquipmentModel } from '../../pages/EquipmentModels/equipmentModels.types.ts'

const created = (equipment: IEquipment) => {
  eventBus.pub('equipment.created', equipment)
}

const updated = (equipment: IEquipment) => {
  eventBus.pub('equipment.updated', equipment)
}

const deleted = (id: IEquipment['id']) => {
  eventBus.pub('equipment.deleted', id)
}

const modelCreated = (equipment: IEquipmentModel) => {
  eventBus.pub('equipment.models.created', equipment)
}

const modelUpdated = (equipment: IEquipmentModel) => {
  eventBus.pub('equipment.models.updated', equipment)
}

const modelDeleted = (id: IEquipmentModel['id']) => {
  eventBus.pub('equipment.models.deleted', id)
}

const maintenanceBlankCreated = (blank: IEquipmentMaintenanceBlank) => {
  eventBus.pub('equipment.maintenance.blank.created', blank)
}

const connectionRequestCreated = (connectionRequest: ILPConnectionRequest) => {
  eventBus.pub('equipment.connection-requests.created', connectionRequest)
}

const equipmentEvents = {
  created,
  updated,
  deleted,
  modelCreated,
  modelUpdated,
  modelDeleted,
  maintenanceBlankCreated,
  connectionRequestCreated,
}
export default equipmentEvents
